import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { useAddToQuickFillListDialog } from '../../hooks/use-add-to-quick-fill-list-dialog';

export const AddToListButton = ({
  locationId,
  padding,
  show = false,
}: {
  locationId: string;
  padding?: string;
  show?: boolean;
}) => {
  const { t } = useTranslation('schedule-quick-fill');
  const { customContactDialogProps, AddToListQuickFillListDialog } = useAddToQuickFillListDialog({
    customContactFormFields: {
      firstName: { value: '', required: true },
      lastName: { value: '', required: true },
      phoneNumber: { value: '', required: true },
      notes: { value: '' },
    },
    selectedLocationId: locationId,
  });

  return (
    <>
      <Button
        iconName='add'
        variant='tertiary'
        css={{ padding, display: show ? 'block' : 'none', zIndex: 1 }}
        {...customContactDialogProps.getTriggerProps()}
      >
        {t('Add to List')}
      </Button>
      {AddToListQuickFillListDialog}
    </>
  );
};
